import { useEffect, useLayoutEffect, useRef } from "react";

import { sdkEventBus, useCallbackState } from "@/sdk";
import { sendEmptySurveyData } from "@/surveys/api/client";

export const useCustomerDroppedHandler = () => {
    const callbackState = useCallbackState();
    const callbackStateRef = useRef(callbackState);

    useLayoutEffect(() => {
        callbackStateRef.current = callbackState;
    }, [callbackState]);

    useEffect(() => {
        const customerDroppedUnsub = sdkEventBus.on("call_customer_dropped", (droppedTask) => {
            if (!callbackStateRef.current) {
                void sendEmptySurveyData(droppedTask, "CUSTOMER_DISCONNECTED");
            }
        });
        return () => customerDroppedUnsub();
    }, []);
};
